function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToptext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 693.03 107.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M195.52,31.77S194.58,0,156.19,0s-42.36,20.99-42.36,32.9c0,33.28,49.35,31.29,49.35,43.68,0,3.97-3.97,5.11-7.56,5.11-8.32,0-8.89-10.02-8.89-10.02l-32.9-.19s-2.65,35.55,40.84,35.55,40.84-28.93,40.84-31.58,3.12-24.77-28.17-31.77c-23.45-5.11-21.18-19.29-14.94-19.29,3.12,0,9.08,1.13,9.08,7.37h34.04Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.41,31.77S596.46,0,558.08,0s-42.36,20.99-42.36,32.9c0,33.28,49.35,31.29,49.35,43.68,0,3.97-3.97,5.11-7.56,5.11-8.32,0-8.89-10.02-8.89-10.02l-32.9-.19s-2.65,35.55,40.84,35.55,40.84-28.93,40.84-31.58,3.12-24.77-28.17-31.77c-23.45-5.11-21.18-19.29-14.94-19.29,3.12,0,9.08,1.13,9.08,7.37h34.04Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.99 0 294.99 106.46 361.55 106.46 361.55 79.61 324.11 79.61 324.11 64.29 358.52 64.29 358.52 41.6 324.86 41.6 324.86 27.23 361.55 27.23 361.55 0 294.99 0",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.57 0 371.57 106.46 401.63 106.46 401.63 54.65 437.37 106.46 470.09 106.46 470.09 0 438.13 0 438.13 54.46 401.26 0 371.57 0",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.03,36.12c0-23.64-22.69-36.12-34.6-36.12h-52.38v106.46h29.88v-37.82l21.56,37.82h35.55l-22.31-39.33s22.31-7.37,22.31-31.01ZM655.02,46.8h-18.44v-19.48c17.68,0,24.49,1.99,24.49,9.74s-3.31,9.74-6.05,9.74Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2,0h-37.63L0,106.46h35.55l5.67-17.4h32.33l6.05,17.4h35.17L76.2,0ZM47.27,67.03l7.94-29.5h1.37l11.11,29.5h-20.42Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.65,0h-52.57v106.46h32.15v-34.6h24.96c6.81,0,27.23-9.45,27.23-34.6S267.38,0,255.65,0ZM250.23,47.34h-14.5v-20.17h7.15s12.7,1.95,12.7,10.08-5.36,10.09-5.36,10.09Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToptext);
export default __webpack_public_path__ + "static/media/toptext.b1321743f1057ffb6aec0f4a13def53b.svg";
export { ForwardRef as ReactComponent };